"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CloudArrowUpSolid: function() {
        return CloudArrowUpSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const CloudArrowUpSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M6.5 18C3.46243 18 1 15.5376 1 12.5C1 9.8925 2.8139 7.70961 5.24923 7.14303C6.0632 4.17816 8.7764 2 12 2C15.866 2 19 5.13401 19 9L18.9999 9.02746C21.2499 9.27616 23 11.1837 23 13.5C23 15.9853 20.9853 18 18.5 18H15V17C15.7678 17 16.5355 16.7071 17.1213 16.1213C18.2929 14.9497 18.2929 13.0503 17.1213 11.8787L14.1213 8.87868C12.9497 7.70711 11.0503 7.70711 9.87868 8.87868L6.87868 11.8787C5.70711 13.0503 5.70711 14.9497 6.87868 16.1213C7.46447 16.7071 8.23223 17 9 17V18H6.5Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M15.7071 13.2929L12.7071 10.2929C12.3166 9.90237 11.6834 9.90237 11.2929 10.2929L8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071L11 13.4142V21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21V13.4142L14.2929 14.7071C14.6834 15.0976 15.3166 15.0976 15.7071 14.7071C16.0976 14.3166 16.0976 13.6834 15.7071 13.2929Z",
            fill: "currentColor"
        })
    ]
}), "CloudArrowUpSolid");
const _default = CloudArrowUpSolid;
